import PRODUCT_REF_TYPE from 'Constants/productRefType';

/**
 * Helper function to determine if products are add-on only
 * @param {Array} priceAdjustments - Array of price adjustments (optional - if not provided, checks all products)
 * @param {Object} initialOrderCosts - Initial order costs data (optional if orderCosts is provided)
 * @param {Object} orderCosts - Current order costs data (optional if initialOrderCosts is provided)
 * @returns {boolean} - True if all products are add-on products only
 */
export const determineIfAddOnOnly = (priceAdjustments, initialOrderCosts, orderCosts) => {
  // If we don't have any cost data at all, default to false for safety
  if (!initialOrderCosts && !orderCosts) {
    return false;
  }

  let productIds = [];

  // If we have price adjustments, use those to get the changed product IDs
  if (priceAdjustments && priceAdjustments.length) {
    productIds = priceAdjustments.map(adjustment => adjustment[3]);
  } else {
    // If no price adjustments, check all products in available cost data
    const availableOrderItems =
      orderCosts?.orderItemsCostsWithDetails ||
      orderCosts?.orderCosts?.orderItemsCostsWithDetails ||
      initialOrderCosts?.orderItemsCostsWithDetails ||
      initialOrderCosts?.orderCosts?.orderItemsCostsWithDetails;

    if (!availableOrderItems || !availableOrderItems.length) {
      return false;
    }

    productIds = availableOrderItems.map(item => item.xProductId);
  }

  // Check each product to see what type it is
  for (const productId of productIds) {
    // Get the correct arrays - handle nested structure, using optional chaining
    const currentOrderItems = orderCosts?.orderItemsCostsWithDetails || orderCosts?.orderCosts?.orderItemsCostsWithDetails;
    const initialOrderItems = initialOrderCosts?.orderItemsCostsWithDetails || initialOrderCosts?.orderCosts?.orderItemsCostsWithDetails;

    // Look for the product in current order costs to get its xRefTypeId
    const currentProduct = currentOrderItems?.find(item => {
      return item.xProductId === productId || item.xProductId == productId;
    });

    // Also check initial order costs in case the product was removed
    const initialProduct = initialOrderItems?.find(item => {
      return item.xProductId === productId || item.xProductId == productId;
    });

    // Get the xRefTypeId from either current or initial product
    const xRefTypeId = currentProduct?.xRefTypeId || initialProduct?.xRefTypeId;

    // If we find any product that is NOT an add-on (xRefTypeId !== 2), return false
    if (xRefTypeId && parseInt(xRefTypeId) !== PRODUCT_REF_TYPE.ADD_ON_PRODUCT) {
      return false;
    }
  }

  // If all changed products are add-ons, return true
  return true;
};
